import React from 'react';
import cx from 'classnames';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core';
import { units } from '@ha/dsl';
import WaveDesktop from 'img-src/wave-bg-desktop.svg';
import WaveMobile from 'img-src/wave-bg-mobile.svg';

export const styles = (t: Theme) =>
  createStyles({
    separator: {
      height: units.rem(3.5),
      backgroundImage: `url(${WaveMobile})`,
      backgroundRepeat: 'repeat-x',
      backgroundPosition: 'bottom left',
      [t.breakpoints.up('sm')]: {
        height: units.rem(5),
        backgroundImage: `url(${WaveDesktop})`,
      },
    },
    rotate: {
      transform: 'rotate(180deg)',
    },
  });

interface Props {
  rotate?: boolean;
}

export const Separator: React.FC<Props & WithStyles<typeof styles>> = ({
  classes,
  rotate = false,
}) => <div className={cx(rotate ? classes.rotate : null, classes.separator)} />;

export default withStyles(styles)(Separator);
